module.exports = __webpack_public_path__ + "img/IMG_20191125_200830.d9bfcec3.jpg";